import { CanDeactivateFn } from '@angular/router';
import { ProfileComponent } from './profile.component';

export const profileCanDeactivateGuard: CanDeactivateFn<ProfileComponent> = component => {
  return component.canDeactivate();
};
